export let BASE_URL = '';
export let BASE_IMAGE_URL = '';

// eslint-disable-next-line no-undef
if (typeof config !== 'undefined' && config.env === 'prod') {
  BASE_URL = 'https://preventiacosmosvnet.azurewebsites.net/api';
  BASE_IMAGE_URL = 'https://preventiab2e9.blob.core.windows.net/user-profile';
} else {
  BASE_URL = 'https://preventiadevblue.azurewebsites.net/api';
  // BASE_URL = 'http://localhost:7071/api';
  // todo: make this the dev url
  BASE_IMAGE_URL = 'https://preventiab2e9.blob.core.windows.net/user-profile';
}

export function extractAxiosErrorMessage (error) {
  if (error?.response?.status === 404) {
    return 'Not found';
  } else if (error?.response?.data?.message) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    return error.response.data.message;
  } else if (error?.request && !error?.response) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest
    return 'No response from server';
  } else if (error?.message) {
    // Something happened in setting up the request that triggered an Error, or
    // there was a server error but no helpful message was returned
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  } else {
    return 'There was a network error.';
  }
}
